export default {
feedback: {
  title: "Masukan",
  placeholder: "Tinggalkan pesan ({ contentLen }/1000 karakter)",
  error: "Ini adalah pesan kesalahan",
  uploadLimit: "Batas unggah gambar dan video",
  send: "Kirim",
  tipTitle: "Bantu kami meningkatkan pengalaman Anda",
  desc1: "Anda dapat mengirimkan pertanyaan apa pun, dan jika diterima, Anda akan mendapatkan hadiah kejutan.",
  desc2: "Jika tidak удобно melalui website, Anda juga bisa mengirim melalui email."
}
};
